export default "__VITE_ASSET__XZNX_82H__"